export default __webpack_public_path__ + "handball-live.png";